export default __webpack_public_path__ + "static/media/logo2.ed1cd477.svg";